function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#3378C8"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M12.293.293l-12 12c-.39.39-.39 1.024 0 1.414.39.39 1.024.39 1.414 0l12-12c.39-.39.39-1.024 0-1.414-.39-.39-1.024-.39-1.414 0z",
  transform: "translate(-1680 -164) translate(1670 154) translate(10 10) translate(5 5)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.293 1.707l12 12c.39.39 1.024.39 1.414 0 .39-.39.39-1.024 0-1.414l-12-12c-.39-.39-1.024-.39-1.414 0-.39.39-.39 1.024 0 1.414z",
  transform: "translate(-1680 -164) translate(1670 154) translate(10 10) translate(5 5)"
}))))));

var SvgIcCloseBlue = function SvgIcCloseBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcCloseBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_close_blue.20602c4e.svg";
export { ForwardRef as ReactComponent };